module.exports = __webpack_public_path__ + "static/media/5.0e99fbd3.png";